type ApiFrequency = 'one-time' | 'recurring';
type CacheFrequency = 'ONE_TIME' | 'RECURRING';

export const mapFrequencyToApiFormat = (frequency?: CacheFrequency | ApiFrequency): ApiFrequency => {
  if (frequency === 'ONE_TIME' || frequency === 'one-time') {
    return 'one-time';
  }

  return 'recurring';
};

export const mapFrequencyToCacheFormat = (frequency?: ApiFrequency | CacheFrequency): CacheFrequency => {
  if (frequency === 'one-time' || frequency === 'ONE_TIME') {
    return 'ONE_TIME';
  }

  return 'RECURRING';
};
